import * as React from 'react'
import * as css from './Modal.module.css'
import clsx from 'clsx'
import { Helmet } from 'react-helmet'

/* eslint-disable jsx-a11y/control-has-associated-label */

const Modal = ({ className, children, onClose, hidden }) => {
	const closeOnEsc = React.useCallback(
		(e) => {
			if (e.key === 'Escape') onClose()
		},
		[onClose],
	)

	React.useEffect(() => {
		if (typeof window === 'undefined') return

		window.addEventListener('keydown', closeOnEsc)

		return () => {
			window.removeEventListener('keydown', closeOnEsc)
		}
	}, [closeOnEsc])

	return (
		<>
			{!hidden && (
				<Helmet>
					<body className="overflow-hidden" />
				</Helmet>
			)}

			<aside className={`${css.root} anim-fadein`} hidden={hidden}>
				<button
					className="absolute inset-0 block h-full w-full bg-gray-400/60 backdrop-blur"
					onClick={onClose}
				/>

				<button className={css.close} onClick={onClose} title="Close modal">
					&times;
				</button>

				<div
					className={clsx(
						className,
						'max-size-full relative z-10 mx-auto overflow-y-auto',
					)}
				>
					{children}
				</div>
			</aside>
		</>
	)
}

export default Modal
